export enum DocumentDetailsFooterType {
  UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT",
  UPLOAD_REPLACEMENT = "UPLOAD_REPLACEMENT",
  ADD_MORE_IMAGES_AND_FINISH_AND_UPLOAD = "ADD_MORE_IMAGES_AND_FINISH_AND_UPLOAD",
  FINISH_AND_UPLOAD = "FINISH_AND_UPLOAD",
  VERIFY_ID_WITH_STRIPE = "VERIFY_ID_WITH_STRIPE",
  DELETE_DOCUMENT = "DELETE_DOCUMENT",
}
